
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"512","height":"512","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.932 4A3.071 3.071 0 0117 7.068a1 1 0 002 0v-.123A5.073 5.073 0 0013.932 2H13V1a1 1 0 00-2 0v1h-.932a5.068 5.068 0 00-1.6 9.875L11 12.72V20h-.932A3.071 3.071 0 017 16.932a1 1 0 00-2 0v.123A5.073 5.073 0 0010.068 22H11v1a1 1 0 002 0v-1h.932a5.068 5.068 0 001.6-9.875L13 11.28V4zm.97 10.021a3.068 3.068 0 01-.97 5.979H13v-6.613zM11 10.613l-1.9-.634A3.068 3.068 0 0110.068 4H11z"}})])
          )
        }
      }
    